module.exports = __webpack_public_path__ + "0cb417a0414974a64c4812cc1fd2f63e.png";